/** @summary Este arquivo contém enums que representam os parâmetros para requisições HTTP de sensores. */

/** @summary Tipo de filtro para a requisição dos sensores. */
export const FILTER_BY = {
	NONE:      0,
	EQUIPMENT: 1
};

/** @summary Opção da área do ativo para a requisição dos valores globais dos sensores. */
export const ASSET_OPTION = {
	NACELLE: 0,
	HUB:     1
};

/** @summary Unidade de medida para a requisição dos valores globais dos sensores. */
export const MEASURE_UNIT = {
	NONE:         -1,
	ACCELERATION: 0,
	SPEED:        1,
};